module.exports = __webpack_public_path__ + "img/bg_game_center.f1ad32dd.jpg";